/**
 * Карточка состояния подписки на главной.
 *
 * Единственная тёмная плашка в приложении: она отвечает на главный вопрос
 * «сколько у меня осталось», и инверсия выделяет её без дополнительного
 * заголовка.
 */
import type { ReactNode } from 'react';

import { Emblem } from './Logo';
import styles from './Hero.module.css';

interface Props {
  status: ReactNode;
  value: ReactNode;
  unit?: ReactNode;
  until?: ReactNode;
  /** Доля прожитого срока, 0..1. Без неё полоса не рисуется. */
  progress?: number | null;
  actions?: ReactNode;
  /** Показать эмблему водяным знаком. Только для короткого значения. */
  emblem?: boolean;
  /** Значение — фраза, а не число: набирается мельче, чтобы уместиться. */
  textual?: boolean;
}

export function Hero({ status, value, unit, until, progress, actions, emblem = false, textual = false }: Props) {
  return (
    <section className={styles.hero}>
      {emblem ? <Emblem size={150} className={styles.emblem} /> : null}
      {/* В правой части карточки лежит эмблема, поэтому верхняя строка
          занята только статусом: всё остальное там спорило бы с ней. */}
      <div className={styles.top}>{status}</div>

      <div className={styles.figure}>
        <span className={textual ? `${styles.number} ${styles.textual}` : styles.number}>{value}</span>
        {unit ? <span className={styles.unit}>{unit}</span> : null}
      </div>
      {until ? <div className={styles.until}>{until}</div> : null}

      {progress !== null && progress !== undefined ? (
        <div className={styles.track}>
          <div
            className={styles.fill}
            style={{ width: `${Math.round(Math.min(Math.max(progress, 0), 1) * 100)}%` }}
          />
        </div>
      ) : null}

      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </section>
  );
}
